// Lib
import React from 'react';

// Components
import ElementTool from './ElementTool';

// Constants
import { ExperimentId } from '../../../../../common/experiments/experimentsConstants';
import { ElementToolSettings, ToolbarItemConfig } from '../../toolbarTypes';
import { isFeatureEnabled } from '../../../../../common/users/utils/userPropertyUtils';
import { ImMNCurrentUser } from '../../../../user/currentUserSelector';

const getDefaultContent = (isSidebarEnabled: boolean) => () => {
    if (isSidebarEnabled) {
        return {
            title: 'New Folder',
        };
    }
};

type BoardToolProps = {
    currentUser: ImMNCurrentUser;
    currentBoardId: string;
    item: ToolbarItemConfig;
    elementTypeObject: any;
    gridSize: number;
    selectOnCreate: boolean;
    editOnCreate: boolean;
    currentUserId: string;
};

const BoardTool = (props: BoardToolProps) => {
    const { item, currentBoardId, gridSize, currentUser, currentUserId } = props;

    const toolSettings = item?.toolSettings as ElementToolSettings | undefined;

    const elementTypeObject = toolSettings?.elementTypeObject || props.elementTypeObject;
    const selectOnCreate = toolSettings?.selectOnCreate ?? props.selectOnCreate;
    const editOnCreate = toolSettings?.editOnCreate ?? props.editOnCreate;
    const toolName = item.name as string;

    const isSidebarEnabled = isFeatureEnabled(ExperimentId.favouritesSidebarPrototype, currentUser);

    return (
        <ElementTool
            name={isSidebarEnabled ? 'Folder' : 'Board'}
            toolName={toolName}
            elementType={elementTypeObject.elementType}
            currentBoardId={currentBoardId}
            currentUserId={currentUserId}
            gridSize={gridSize}
            editOnCreate={editOnCreate}
            selectOnCreate={selectOnCreate}
            iconName={isSidebarEnabled ? 'element-folder' : 'element-board'}
            getDefaultContent={getDefaultContent(isSidebarEnabled)}
        />
    );
};

export default BoardTool;
